<template>
    <div>
        <div class="snippet event-domain-snippet">

        <div class="form-group row">
            <div class="col-lg-8">
                <label>Show Socials link on footer</label>
                <br />
                <div class="custom-control custom-switch">
                <input-switch name="skybox_is_custom" :value="item.show_social_footer" id="headerBannerVideoSwitch" class="custom-control-input" @change="updateIsShowSocialFooter" />
                &nbsp; 
                &nbsp;    
                <label
                      :class="item.show_social_footer ? 'text-success' : 'text-danger'"
                      for="customEF"
                    >{{item.show_social_footer ? 'Yes' : 'No'}}</label>
                </div>
            </div>

        </div> 

        <div class="form-group row">
            <div class="col-lg-8">
                <label>Show Partners in Footer</label>
                <br />
                <div class="custom-control custom-switch">
                <input-switch name="skybox_is_custom" :value="item.show_partners_footer" id="socialHeaderSwitch" class="custom-control-input" @change="updateIsShowPartnerFooter" />
                &nbsp; 
                &nbsp;    
                <label
                      :class="item.show_partners_footer ? 'text-success' : 'text-danger'"
                      for="customEF"
                    >{{item.show_partners_footer ? 'Yes' : 'No'}}</label>
                </div>
            </div>

        </div>
        <div class="form-group row">
            <div class="col-lg-8">
                <label>Show Newsletter(Subscriber List) in Footer</label>
                <br />
                <div class="custom-control custom-switch">
                <input-switch name="skybox_is_custom" :value="item.show_newsletter_footer" id="socialHeaderSwitch" class="custom-control-input" @change="updateIsShowNewsLetterFooter" />
                &nbsp; 
                &nbsp;    
                <label
                      :class="item.show_newsletter_footer ? 'text-success' : 'text-danger'"
                      for="customEF"
                    >{{item.show_newsletter_footer ? 'Yes' : 'No'}}</label>
                </div>
            </div>

        </div> 
        

        
</div>
</div>
 
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import InputSwitch from "@/components/Commons/InputSwitch";

export default {
    name: "ThemeContentsTab",
    components: {
      InputSwitch
     
  },
    data() {
        return {
            event_theme: null,
        };
    },
    computed: {
        ...mapGetters("LandingPageSettingsSingle", [
            "item",
            "event_type",
            "skyboxes",
            "environments"
        ])
    },
    watch: {
        
    },
    methods: {
        ...mapActions("LandingPageSettingsSingle", [
            "setEvent",
            "setIsShowFooterPartner",
            "setIsShowSocialFooter",
            "setIsShowFooterNewsLetter"

        ]),

        validate_file(fileInfo) {
            if (_.has(fileInfo, 'key'))
                return fileInfo;
        return null;
        },
        updateIsShowSocialFooter(e){
            this.setIsShowSocialFooter(e.target.checked);
        },
        updateIsShowPartnerFooter(e){
            this.setIsShowFooterPartner(e.target.checked);
        },
        updateIsShowNewsLetterFooter(e){
            this.setIsShowFooterNewsLetter(e.target.checked);
        }
        
      
    }
}
</script>

<style scoped>

</style>